import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Search } from '../components/Search';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchLounges,
  fetchRightBar,
  fetchBestViewd,
} from '../redux/lounges/slice';
import { useForm } from 'react-hook-form';
import { useAppDispatch } from '../redux/store';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { GET_BASE_URL_IMAGE } from '../constants/apiEndpoints';
import { ChatImageWithFallback } from './ChatImageWithFallback';
// import midbanner from '../assets/img/user_dp.png';
type RightLoungeBestProps = {
  onNavigate?: () => void;
};

const shuffleTags = (items: any[]) => {
  if (!Array.isArray(items)) {
    return [];
  }

  const shuffled = [...items];
  for (let index = shuffled.length - 1; index > 0; index -= 1) {
    const swapIndex = Math.floor(Math.random() * (index + 1));
    [shuffled[index], shuffled[swapIndex]] = [
      shuffled[swapIndex],
      shuffled[index],
    ];
  }
  return shuffled;
};

const isBestSidebarImagePost = (item: any) =>
  typeof item?.chat_img === 'string' && item.chat_img.includes('c_img');

// Fantasy Falls early access: show the world link only to these members
// while the land is in soft launch. Widen (or drop the gate) to open it up.
const FANTASY_FALLS_EARLY_ACCESS = ['admin', 'kelly2', 'mrsprincecharming'];

const RightLoungeBest = ({ onNavigate }: RightLoungeBestProps = {}) => {
  const ffUserName = (localStorage.getItem('user_name') || '').toLowerCase();
  const showFantasyFalls = FANTASY_FALLS_EARLY_ACCESS.includes(ffUserName);
  const dispatch = useAppDispatch();
  let sortType: any = null;
  let currentPage: any = null;

  const [tag, SetTag] = useState<any | string>([]);
  const [bestDay, SetBestDay] = useState<any | string>([]);
  const [bestWeek, SetBestWeek] = useState<any | string>([]);
  const [bestMonth, SetBestMonth] = useState<any | string>([]);
  const [banner, SetBanner] = useState<any | string>([]);
  const shuffledTags = useMemo(() => shuffleTags(tag), [tag]);
  const imageBackedBestDay = useMemo(
    () => (Array.isArray(bestDay) ? bestDay.filter(isBestSidebarImagePost) : []),
    [bestDay]
  );
  const imageBackedBestWeek = useMemo(
    () => (Array.isArray(bestWeek) ? bestWeek.filter(isBestSidebarImagePost) : []),
    [bestWeek]
  );
  const imageBackedBestMonth = useMemo(
    () => (Array.isArray(bestMonth) ? bestMonth.filter(isBestSidebarImagePost) : []),
    [bestMonth]
  );
  useEffect(() => {
    // window.scrollTo(0, 0);

    dispatch(fetchRightBar({ sortType, currentPage })).then((res: any) => {
      SetTag(res.payload[0].tagdata);
      SetBestDay(res.payload[0].bestoftheday);
      SetBestWeek(res.payload[0].bestoftheweek);
      SetBestMonth(res.payload[0].bestofthemonth);
      SetBanner(res.payload[0].banner);
    });
  }, []);

  /*   const formatText = (text: any) => {
    let content = text?.split(/((?:#|@|https?:\/\/[^\s]+)[a-zA-Z]+)/);
    let hashtag;

    return content?.map((word: any) => {
      if (word.startsWith('#')) {
        hashtag = word.replace('#', '');
        return (
          <Link to={`/disneyland/hash/${hashtag}`}>
            <a style={{ color: 'blue', textDecoration: 'underline' }}>{word}</a>
          </Link>
        );
      } else {
        return word;
      }
    });
  }; */

  function removeTags(string: any) {
    let newstring = string
      .replace(/<[^>]*>/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
    let content = newstring?.split(/((?:#|@|https?:\/\/[^\s]+)[a-zA-Z]+)/);
    let hashtag;

    return content?.map((word: any) => {
      if (word.startsWith('#')) {
        hashtag = word.replace('#', '');
        return (
          <Link to={`/disneyland/hash/${hashtag}`}>
            <a style={{ color: 'blue', textDecoration: 'underline' }}>{word}</a>
          </Link>
        );
      } else {
        return word;
      }
    });
  }
  const [open, setIsopen] = useState(false);

  const ToggleSidebar = () => {
    open === true ? setIsopen(false) : setIsopen(true);
  };
  //console.log(window.location.origin);
  return (
    <>
      {/*-mw-right-c section start -*/}
      <div className='mw-right-c rounded mt-3'>
        <div className='card-body'>
          {showFantasyFalls && (
            <a
              href='https://mousewait.com/fantasy-falls/'
              style={{
                display: 'block',
                margin: '8px 0 12px',
                padding: '14px 16px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #1d3a2f 0%, #2c5744 55%, #46704f 100%)',
                border: '1px solid #f0c878',
                color: '#f7ecd7',
                textDecoration: 'none',
                textAlign: 'center',
              }}
            >
              <div style={{ fontSize: 18, fontWeight: 700, letterSpacing: '0.02em' }}>
                🏔️ Fantasy Falls
              </div>
              <div style={{ fontSize: 13, marginTop: 4, opacity: 0.92 }}>
                Walk the land, chat live, show off your stickers — early access
              </div>
            </a>
          )}

          {/* <h6 className='donate-h'>
            Your Donations Help Us Make MouseWait Better!
          </h6> */}

          {/* <div className='don-c text-center paypal-cc'>
            <form action='https://www.paypal.com/cgi-bin/webscr' method='post'>
              <input type='hidden' name='cmd' defaultValue='_s-xclick' />
              <input
                type='hidden'
                name='hosted_button_id'
                defaultValue='R4S4DFM9R2R3U'
              />
              <input
                type='image'
                src='https://www.paypal.com/en_US/i/btn/btn_donateCC_LG.gif'
                name='submit'
                alt='PayPal - The safer, easier way to pay online!'
              />
            </form>
          </div> */}

          <div className='mw-week-s mt-2'>
            {/* best of the day */}
            <div className='mwr-Best-Week'>
              <a href={`${window.location.origin}/disneyland/d/L/most-viewed`}>
                <h2>Best of The Day</h2>
              </a>

              <div className='mw-amazon-support'>
                <a
                  href='https://amzn.to/OUTbbI'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Support MouseWait by using this Amazon link
                </a>
              </div>

              {imageBackedBestDay.map((bitem: any) => (
                <div
                  key={bitem.chat_id ?? bitem.mapping_url ?? bitem.chat_img}
                  className='bw-s best-day'
                >
                  <Link
                    to={`/disneyland/lands-talk/${bitem.mapping_url?.replace(
                      /([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\? ])+/g,
                      '-'
                    )}`}
                  >
                    <ChatImageWithFallback
                      filename={bitem.chat_img}
                      preferredQuality='thumbnail'
                      className='card-img-top img-fluid'
                      alt='img'
                    />
                  </Link>

                  <Link
                    to={`/disneyland/lands-talk/${bitem.mapping_url?.replace(
                      /([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\? ])+/g,
                      '-'
                    )}`}
                  >
                    <h6 className='mwr-best-link-title'>
                      {removeTags(
                        bitem.chat_msg.split(/\s+/).slice(0, 10).join(' ')
                      )}
                    </h6>
                  </Link>
                </div>
              ))}
            </div>

            {/* best of the week */}
            <div className='mwr-Best-Week'>
              <a href={`${window.location.origin}/disneyland/w/L/most-viewed`}>
                <h2>Best of The Week</h2>
              </a>

              {imageBackedBestWeek.map((bitem: any) => (
                <div
                  key={bitem.chat_id ?? bitem.mapping_url ?? bitem.chat_img}
                  className='bw-s best-day'
                >
                  <Link
                    to={`/disneyland/lands-talk/${bitem.mapping_url?.replace(
                      /([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\? ])+/g,
                      '-'
                    )}`}
                  >
                    <ChatImageWithFallback
                      filename={bitem.chat_img}
                      preferredQuality='thumbnail'
                      className='card-img-top img-fluid'
                      alt='img'
                    />
                  </Link>

                  <Link
                    to={`/disneyland/lands-talk/${bitem.mapping_url?.replace(
                      /([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\? ])+/g,
                      '-'
                    )}`}
                  >
                    <h6 className='mwr-best-link-title'>
                      {removeTags(
                        bitem.chat_msg.split(/\s+/).slice(0, 10).join(' ')
                      )}
                    </h6>
                  </Link>
                </div>
              ))}
            </div>

            {/* best of the month */}
            <div className='mwr-Best-Week'>
              <a href={`${window.location.origin}/disneyland/m/L/most-viewed`}>
                <h2>Best of The Month</h2>
              </a>

              {imageBackedBestMonth.map((bitem: any) => (
                <div
                  key={bitem.chat_id ?? bitem.mapping_url ?? bitem.chat_img}
                  className='bw-s best-day'
                >
                  <Link
                    to={`/disneyland/lands-talk/${bitem.mapping_url?.replace(
                      /([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\? ])+/g,
                      '-'
                    )}`}
                  >
                    <ChatImageWithFallback
                      filename={bitem.chat_img}
                      preferredQuality='thumbnail'
                      className='card-img-top img-fluid'
                      alt='img'
                    />
                  </Link>

                  <Link
                    to={`/disneyland/lands-talk/${bitem.mapping_url?.replace(
                      /([~!@#$%^&*()_+=`{}\[\]\|\\:;'<>,.\? ])+/g,
                      '-'
                    )}`}
                  >
                    <h6 className='mwr-best-link-title'>
                      {removeTags(
                        bitem.chat_msg.split(/\s+/).slice(0, 10).join(' ')
                      )}
                    </h6>
                  </Link>
                </div>
              ))}
            </div>

            <div className='mwr-text-s'>
              <div className='wwr-link tags'>
                <ul>
                  {' '}
                  {shuffledTags.map((item: any) => (
                    <li key={item.id ?? item.tags_name} className={`tag${item.id}`}>
                      <Link
                        onClick={onNavigate}
                        to={`/disneyland/tag/${item.tags_name?.replaceAll(
                          ' ',
                          '-'
                        )}`}
                      >
                        {item.tags_name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* mwr-add-section start */}

            <div className='mwr-ad1'>
              {banner.map((item: any) => (
                <a
                  key={item.banner_id ?? item.banner_image ?? item.banner_url}
                  href={`${item.banner_url}`}
                >
                  <img
                    src={
                      GET_BASE_URL_IMAGE +
                      '/disneyland/images/banner_fullsize/' +
                      item.banner_image
                    }
                    className='card-img-top img-fluid'
                    alt='img'
                  />
                </a>
              ))}
            </div>
            {/* mwr-add-section end */}

            <div className='week-link-3 text-center'>
              <ul className='m-0 p-0'>
                <li>
                  <a href={'https://apps.apple.com/us/app/mousewait-disneyland-lounge/id331771613'}>MouseWait Disneyland iOS</a>
                </li>
                <li>
                  <a
                    href={
                      'https://apps.apple.com/us/app/mousewait-for-disney-world/id437292247'}>MouseWait Disney World iOS</a>
                </li>
                <li>
                  <a href={'https://facebook.mousewait.com'}>
                    Follow us on Facebook
                  </a>
                </li>
                <li>
                  <a href={'https://twitter.com/mousewait'}>
                    Follow us on Twitter
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <br />
              <div
                style={{
                  textAlign: 'center',
                  display: 'block',
                  paddingLeft: '20px',
                }}
              >
                
              </div>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
      {/*-mw-right-c section end -*/}
    </>
  );
};

export default RightLoungeBest;
